export default function About() {
  return (
    <section id="chi-siamo" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
              Chi Siamo
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              <strong className="text-slate-900">LA.RA. SERVICE SRL</strong> è una società italiana specializzata nelle lavorazioni meccaniche conto terzi e nel commercio all'ingrosso di ferro per l'edilizia e strutture metalliche destinate ai settori edile e meccanico.
            </p>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              Con sede operativa in <strong className="text-slate-900">Toscana</strong>, operiamo su tutto il territorio nazionale, collaborando con clienti distribuiti in tutta Italia, e stiamo intraprendendo un percorso strutturato di espansione verso i mercati esteri.
            </p>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Ci distinguiamo per <strong className="text-slate-900">affidabilità</strong>, <strong className="text-slate-900">qualità delle lavorazioni</strong>, <strong className="text-slate-900">puntualità nelle consegne</strong> e una costante attenzione alle esigenze specifiche del cliente.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="bg-slate-50 rounded-xl p-6">
                <i className="ri-award-line text-4xl text-slate-700 mb-3"></i>
                <h4 className="text-xl font-bold text-slate-900 mb-2">Qualità Certificata</h4>
                <p className="text-sm text-slate-600">Standard elevati in ogni lavorazione</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-6">
                <i className="ri-time-line text-4xl text-slate-700 mb-3"></i>
                <h4 className="text-xl font-bold text-slate-900 mb-2">Puntualità</h4>
                <p className="text-sm text-slate-600">Consegne sempre nei tempi concordati</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-6">
                <i className="ri-customer-service-line text-4xl text-slate-700 mb-3"></i>
                <h4 className="text-xl font-bold text-slate-900 mb-2">Assistenza</h4>
                <p className="text-sm text-slate-600">Supporto tecnico personalizzato</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-6">
                <i className="ri-map-pin-line text-4xl text-slate-700 mb-3"></i>
                <h4 className="text-xl font-bold text-slate-900 mb-2">Copertura</h4>
                <p className="text-sm text-slate-600">Servizio su tutto il territorio nazionale</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/d45482f5b64169322a812bd838b8de89.jpg"
                alt="LA.RA. SERVICE Team"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-gradient-to-br from-slate-700 to-slate-900 text-white rounded-2xl p-8 shadow-2xl max-w-xs">
              <p className="text-5xl font-bold mb-2">2023-2025</p>
              <p className="text-lg">Crescita costante del fatturato e consolidamento sul mercato nazionale</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}